import { IconId, IconReceipt, IconReceipt2, IconUsers } from "@tabler/icons-react";

import {
  PRACTICE_LEDGER_SEARCH_OPTION,
  PRACTICE_LEDGER_SORT_COLUMN,
} from "@/billing/types/practice-ledger";

import type { PracticeLedgerColumn, PracticeLedgerSummaryCard } from "../types/ledger-ui";

/** Shared copy for the practice Ledger refresh control (tooltip + aria-label). */
export const REFRESH_PRACTICE_LEDGER_TABLE_LABEL = "Refresh ledger table";

export const TABLE_HEADER_HEIGHT = 72;

export const LOAD_ERROR_MESSAGE = "Unable to load the ledger. Please try again.";
export const EMPTY_MESSAGE = "No ledger activity for this date range.";
export const NO_SEARCH_RESULTS_MESSAGE = "No ledger activity matches your search.";

export const SEARCH_BAR_WIDTH = 480;
export const SEARCH_LABEL = "Search By";
export const CLEAR_SEARCH_LABEL = "Clear search";
/** Long enough that typing a name does not refetch the window per character. */
export const PRACTICE_LEDGER_SEARCH_DEBOUNCE_MS = 300;

export const SEARCH_OPTIONS = [
  { label: "Client", value: PRACTICE_LEDGER_SEARCH_OPTION.Client },
  { label: "Insurance", value: PRACTICE_LEDGER_SEARCH_OPTION.Insurance },
];

export const SEARCH_PLACEHOLDERS = {
  [PRACTICE_LEDGER_SEARCH_OPTION.Client]: "Search by Client Name",
  [PRACTICE_LEDGER_SEARCH_OPTION.Insurance]: "Search by Insurance Name",
};

export const EXPORT_CSV_LABEL = "Export CSV";
export const EXPORT_CSV_ICON_SIZE = 16;

export const PRACTICE_LEDGER_NAMED_PRESET_TEST_IDS = {
  "current-month": "practice-ledger-date-range-current-month-option",
  "last-30-days": "practice-ledger-date-range-last-30-days-option",
  "last-90-days": "practice-ledger-date-range-last-90-days-option",
} as const;

export const PRACTICE_LEDGER_COLUMNS: PracticeLedgerColumn[] = [
  { key: "client-name", label: "Client Name", width: "22%" },
  { key: "type", label: "Type", width: "12%" },
  {
    key: "transaction-date",
    label: "Transaction Date",
    width: "18%",
    sortKey: PRACTICE_LEDGER_SORT_COLUMN.TransactionDate,
  },
  { key: "source", label: "Source", width: "18%" },
  { key: "amount", label: "Amount", width: "15%", align: "right" },
  { key: "statement-id", label: "#ID", width: "15%" },
];

export const PRACTICE_LEDGER_COLUMN_SPAN = PRACTICE_LEDGER_COLUMNS.length;

export const PRACTICE_LEDGER_SUMMARY_CARDS: PracticeLedgerSummaryCard[] = [
  {
    id: "total-charges",
    title: "Total Charges",
    totalKey: "totalCharges",
    icon: IconReceipt,
    iconColor: "var(--mantine-color-gray-6)",
  },
  {
    id: "total-received",
    title: "Total Payments Received",
    totalKey: "totalReceived",
    icon: IconReceipt2,
    iconColor: "var(--mantine-color-green-6)",
  },
  {
    id: "from-clients",
    title: "Total Payments from Clients",
    totalKey: "fromClients",
    icon: IconUsers,
    iconColor: "var(--mantine-color-blue-6)",
  },
  {
    id: "from-insurance",
    title: "Total Payments from Insurance",
    totalKey: "fromInsurance",
    icon: IconId,
    iconColor: "var(--mantine-color-gray-6)",
  },
];
